export default ()=>({
    openAccordions: [],
    init(){

    },
    toggleAccordionVideo(event) {
        const videoContainer = event.target.closest('.media-wrapper').querySelector('.accordion__video')

        if (videoContainer.paused) {
            videoContainer.play()
            event.target.innerText = 'Pause'
        } else {
            videoContainer.pause()
            event.target.innerText = 'Play'
        }
    },
    toggleAccordion(accordionNumber) {
        const index = this.openAccordions.indexOf(accordionNumber);
        if (index === -1) {
            this.openAccordions.push(accordionNumber);
        } else {
            this.openAccordions.splice(index, 1);
        }
    },
    openAccordionByType(sectionType) {
        if (!sectionType) return;
        const el = this.$el.querySelector('[data-section-type="' + sectionType + '"]');
        if (!el) return;
        const accordionIndex = el.getAttribute('data-accordion-index');
        if (!accordionIndex || this.openAccordions.includes(accordionIndex)) return;
        this.openAccordions.push(accordionIndex);
    }
})
